import { createSlice } from "@reduxjs/toolkit";

const rddSlice = createSlice({
  name: "rdds",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {
    fetchRddsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchRddsSuccess: (state, action) => {
      state.loading = false;
      state.items = action.payload;
    },
    fetchRddsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchRddsRequest,
  fetchRddsSuccess,
  fetchRddsFailure,
} = rddSlice.actions;

export default rddSlice.reducer;